export default "__VITE_ASSET__bXDMO4zh__"